// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1T7FD","col":"Table_col__20u_6","fulfillmentStatus":"Table_fulfillmentStatus__UD0MT","emailCol":"Table_emailCol__1ZHFK"};